import { render } from "./LbrxDisplayBiatThirdTheme.vue?vue&type=template&id=2e4d4aec&scoped=true"
import script from "./LbrxDisplayBiatThirdTheme.vue?vue&type=script&lang=js"
export * from "./LbrxDisplayBiatThirdTheme.vue?vue&type=script&lang=js"

import "./LbrxDisplayBiatThirdTheme.vue?vue&type=style&index=0&id=2e4d4aec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4d4aec"]])

export default __exports__